<template>
  <div id="printContent" class="hidden">
    <a-card v-if="personel && personel.proposal" title="اطلاعات فردی">
      <div class="grid sm:grid-cols-1 md:grid-cols-3 md:gap-3 lg:grid-cols-3 lg:gap-3">
        <a-form-item label="نام و نام خانوادگی">
          {{ personel.name }}
        </a-form-item>
        <a-form-item label="نام انگلیسی">
          {{ personel.name_en }}
        </a-form-item>
        <a-form-item label="کدملی">
          {{ personel.ncode }}
        </a-form-item>
        <a-form-item label="شماره پرسنلی">
          {{ personel.personel_id }}
        </a-form-item>
        <a-form-item label="موبایل">
          {{ personel.proposal.mobile }}
        </a-form-item>
        <a-form-item label="شهر متقاضی شغل">
          {{ personel.proposal.for_cities.join(' , ') }}
        </a-form-item>
        <a-form-item label="شغل متقاضی">
          {{ personel.proposal.job_title }}
        </a-form-item>
        <a-form-item label="واحد کار متقاضی">
          {{ personel.unit }}
        </a-form-item>
        <a-form-item label="نام پدر">
          {{ personel.proposal.father_name }}
        </a-form-item>
        <a-form-item label="تاریخ تولد">
          {{ personelBirthDate | jdate }}
        </a-form-item>
        <a-form-item label="شماره شناسنامه">
          {{ personel.proposal.iden_id }}
        </a-form-item>
        <a-form-item label="سریال شناسنامه">
          {{ personel.proposal.iden_serial }}
        </a-form-item>
        <a-form-item label="محل صدور">
          {{ personel.proposal.iden_place }}
        </a-form-item>
        <a-form-item label="محل تولد">
          {{ personel.proposal.birth_place }}
        </a-form-item>
        <a-form-item label="ایمیل">
          {{ personel.proposal.email }}
        </a-form-item>
        <a-form-item label="تلفن ثابت">
          {{ personel.proposal.phone }}
        </a-form-item>
        <a-form-item label="حقوق درخواستی">
          {{ personel.proposal.requested_salary }}
        </a-form-item>
        <a-form-item label="جنسیت">
          <a-radio-group v-model="personel.proposal.gender">
            <a-radio :value="1">
              مرد
            </a-radio>
            <a-radio :value="2">
              زن
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="وضعیت تاهل">
          <a-radio-group v-model="personel.proposal.marriage_sts">
            <a-radio :value="2">
              متاهل
            </a-radio>
            <a-radio :value="1">
              مجرد
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="وضعیت مسکن">
          <a-radio-group v-model="personel.proposal.house_sts">
            <a-radio :value="1">
              مالک
            </a-radio>
            <a-radio :value="2">
              مستاجر
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="آدرس" class="col-span-3">
          {{ personel.proposal.address }}
        </a-form-item>
        <a-form-item label="تلفن ضروری">
          {{ personel.proposal.phone_emergency }}
        </a-form-item>
        <a-form-item label="نام فرد">
          {{ personel.proposal.phone_emergency_name }}
        </a-form-item>
        <a-form-item label="نسبت">
          {{ personel.proposal.phone_emergency_related }}
        </a-form-item>
        <a-form-item label="شماره کارت">
          {{ personel.bank_card_number }}
        </a-form-item>
        <a-form-item label="شماره حساب">
          {{ personel.bank_account }}
        </a-form-item>
        <a-form-item label="شماره بیمه">
          {{ personel.insurance_no }}
        </a-form-item>
        <a-form-item label="وضعیت بیمه">
          <a-radio-group v-model="personel.insurance_sts">
            <a-radio :value="-1">
              ندارد
            </a-radio>
            <a-radio :value="1">
              دارد
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="تعداد فرزند">
          {{ personel.proposal.count_child }}
        </a-form-item>
        <a-form-item label="وضعیت نظام وظیفه">
          {{
            {1: 'معاف', 2: 'مشمول', 3: 'پایان خدمت'}[personel.proposal.military_sts]
          }}
        </a-form-item>
      </div>
    </a-card>
    <a-card v-if="personalDetails && personalDetails.family" title="اطلاعات خانوادگی" class="mt-5">
      <template v-for="(item,index) in personalDetails.family">
        <div class="grid sm:grid-cols-1 md:grid-cols-3 md:gap-3 lg:grid-cols-3 lg:gap-3">
          <a-form-item label="شناسه">
            {{ personalDetails.family[index].id }}
          </a-form-item>
          <a-form-item label="نام">
            {{ personalDetails.family[index].name }}
          </a-form-item>
          <a-form-item label="نسبت">
            {{ personalDetails.family[index].relation }}
          </a-form-item>
          <a-form-item label="مقطع">
            {{
              personalDetails.family[index].edu_level ?
                  grade[personalDetails.family[index].edu_level.toString()] :
                  null
            }}
          </a-form-item>
          <a-form-item label="رشته تحصیلی">
            {{ personalDetails.family[index].edu_title }}
          </a-form-item>
          <a-form-item label="شغل">
            {{ personalDetails.family[index].job }}
          </a-form-item>
        </div>
        <a-divider/>
      </template>
    </a-card>
    <a-card v-if="personalDetails && personalDetails.education" title="اطلاعات تحصیلی" class="mt-5">
      <template v-for="(item,index) in personalDetails.education">
        <div class="grid sm:grid-cols-1 md:grid-cols-3 md:gap-3 lg:grid-cols-3 lg:gap-3">
          <a-form-item label="شناسه">
            {{ personalDetails.education[index].id }}
          </a-form-item>
          <a-form-item label="مقطع">
            {{
              personalDetails.education[index].level ?
                  grade[personalDetails.education[index].level.toString()] :
                  null
            }}
          </a-form-item>
          <a-form-item label="دانشگاه">
            {{ personalDetails.education[index].university }}
          </a-form-item>
          <a-form-item label="رشته تحصیلی">
            {{ personalDetails.education[index].title }}
          </a-form-item>
          <a-form-item label="گرایش">
            {{ personalDetails.education[index].trend }}
          </a-form-item>
          <a-form-item label="سال شروع">
            {{ personalDetails.education[index].start_at }}
          </a-form-item>
          <a-form-item label="سال خاتمه">
            {{ personalDetails.education[index].end_at }}
          </a-form-item>
        </div>
        <a-divider/>
      </template>
    </a-card>
    <a-card v-if="personalDetails && personalDetails.traning" title="سوابق آموزشی" class="mt-5">
      <template v-for="(item,index) in personalDetails.traning">
        <div class="grid sm:grid-cols-1 md:grid-cols-3 md:gap-3 lg:grid-cols-3 lg:gap-3">
          <a-form-item label="شناسه">
            {{ personalDetails.traning[index].id }}
          </a-form-item>
          <a-form-item label="مرکز برگزاری">
            {{ personalDetails.traning[index].university }}
          </a-form-item>
          <a-form-item label="عنوان دوره ">
            {{ personalDetails.traning[index].title }}
          </a-form-item>
          <a-form-item label="سال">
            {{ personalDetails.traning[index].start_at }}
          </a-form-item>
          <a-form-item label="امکان ارائه گواهینامه دارم">
            <a-checkbox v-model="personalDetails.traning[index].has_certificate"/>
          </a-form-item>
        </div>
        <a-divider/>
      </template>
    </a-card>
    <a-card v-if="personalDetails && personalDetails.jobs_history" title="سوابق کاری" class="mt-5">
      <template v-for="(item,index) in personalDetails.jobs_history">
        <div class="grid sm:grid-cols-1 md:grid-cols-3 md:gap-3 lg:grid-cols-3 lg:gap-3">
          <a-form-item label="شناسه">
            {{ personalDetails.jobs_history[index].id }}
          </a-form-item>
          <a-form-item label="نام سازمان ">
            {{ personalDetails.jobs_history[index].university }}
          </a-form-item>
          <a-form-item label="عنوان شغل">
            {{ personalDetails.jobs_history[index].title }}
          </a-form-item>
          <a-form-item label="دلیل خاتمه">
            {{ personalDetails.jobs_history[index].note }}
          </a-form-item>

          <a-form-item label="سال شروع">
            {{ personalDetails.jobs_history[index].start_at }}
          </a-form-item>
          <a-form-item label="سال خاتمه">
            {{ personalDetails.jobs_history[index].end_at }}
          </a-form-item>
        </div>
        <a-divider/>
      </template>
    </a-card>
  </div>
</template>

<script>
export default {
  name: "printContent",
  props: {
    personel: Object,
    personalDetails: Object,
    grade: Object,
    personelBirthDate: [String,null]
  }
}
</script>

<style scoped>

</style>